import { defineComponent as _defineComponent } from 'vue'
import { fetchGetProductionNcSetting } from '@/apis/materialList/index'
import { getProductionLineSetting } from '@/apis/paibanHistory/index'
import { comparePreLayoutSetting } from '@/apis/preLayoutSetting/index'
import { checkAndShowNoPermissionToast } from '@/auth/user_function'
import { USER_PERMISSION_KEY } from '@/data/auth'
import router from '@/router/index'
import store from '@/store'
import { updateLocalPreference } from '@/store/modules/preferencesSetting/index'
import { translate } from '@/util/commonFun'
import { buryPointApi, genOrderAddress } from '@/util/commonFuncs'
import { dealPaibanData, dealPreLayoutDataLabelID } from '@/util/dealPaibanData'
import { saveDataJsonToOssForRecord } from '@/util/saveFile'
import { Modal, message } from 'ant-design-vue'
import axios from 'axios'
import { computed, onMounted, ref, watch } from 'vue'
import Vue from 'vue'

import { dealPreLayoutSettingFromNCSetting } from '../materialsList/util/preLayoutDeal'
import MPaibanTaskConflictModal from './components/m-paiban-task-conflict-modal.vue'
import MPaibanTaskList from './components/m-paiban-task-list.vue'
import {
  PaibanTaskActionEnum,
  PaibanTaskStatusEnum,
  statusOptions,
} from './types'
import type { PaibanTaskAction, PaibanTaskRow } from './types'

type statusType = PaibanTaskStatusEnum | 0


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const orderNo = ref('')

const status = ref<statusType>(0)

const page = ref(1)

const limit = ref(10)

const confilict = ref(null)
const confilictTotal = ref(0)
const productionLineName = ref('')

const hasConflict = computed(() => confilictTotal.value > 0)

const isOkLoading = ref(false)
/** 是否加载中 */
const isLoading = computed(
  () => store.state.paibanTaskStore?.isLoading ?? false
)
/** 显示任务列表 */
const displayTaskList = computed(
  () => store.state.paibanTaskStore?.taskList ?? []
)
/** 总任务数 */
const total = computed(() => store.state.paibanTaskStore?.total ?? 0)

/** 最大页码 */
const maxPage = computed(() =>
  Math.max(1, Math.ceil(total.value / limit.value))
)

function handleSearch(payLoad: { orderNo: string; status: statusType }): void {
  orderNo.value = payLoad.orderNo
  status.value = payLoad.status

  page.value = 1
  loadTaskList()
}

async function loadTaskList() {
  await store.dispatch('paibanTaskStore/fetchPaibanTaskList', {
    order_no: orderNo.value,
    status: status.value === 0 ? undefined : status.value,
    page: page.value,
    limit: limit.value,
  })
}

function handlePageChange(current: number): void {
  page.value = current
  loadTaskList()
}

function handlePageSizeChange(_current: number, size: number): void {
  limit.value = size

  page.value = 1
}

const currentTaskData = ref(null as any)

function routerToPage(
  record: PaibanTaskRow,
  type: PaibanTaskAction,
  hasPaibanData: boolean
) {
  store.commit('setPaibanTaskObj', {
    ...record,
    ncSetting: store.state.ncSetting,
  })
  if (type == 'planPreview') {
    if (hasPaibanData) {
      router.push('/newPaiban')
    } else {
      router.push('/materialList')
    }
  } else {
    router.push('/materialList')
  }
}

/** 处理排版任务操作 */
async function handleAction(type: PaibanTaskAction, record: PaibanTaskRow) {
  const { production_line_id, production_line_name } = record
  switch (type) {
    case 'planPreview':
    case 'startList':
      store.commit('paibanTaskStore/setIsLoading', true)

      try {
        const requestUrl = record.request_url
        const paibanDataJsonArr = record.resultUrlArr ?? []
        const plankDataJson = record.plank_url
        // 这里作用是为了将点击开料清单和排版预览操作分开处理，开料清单时不需要获取排版数据
        const paibanDataArr =
          type === 'startList'
            ? []
            : await Promise.all(
                paibanDataJsonArr.map(async (item) => {
                  const res = await axios.get(item)
                  return res.data
                })
              )
        const requestData = requestUrl
          ? (await axios.get(requestUrl)).data
          : null
        const plankData = plankDataJson
          ? (await axios.get(plankDataJson)).data
          : null
        if (requestData) {
          const layoutData = JSON.parse(requestData.data.layout_data)
          const layoutConfig = layoutData.layoutConfig
          const standardPlank = {
            plankWidth: layoutConfig.outWidth,
            plankHeight: layoutConfig.outHeight,
            plankEdgeOff: layoutConfig.margin,
            standard_plank_id: layoutConfig.standardPlankId,
            default_selected: true,
          }
          store.commit('setSelectStandardPlank', standardPlank)
          store.commit('setDefaultSelectedPlank', standardPlank)
          store.commit('setActivePaibanWay', [plankData.paibanWay])
        }
        store.commit(
          'setPreLayoutData',
          dealPreLayoutDataLabelID(plankData.preLayoutData)
        )
        store.commit('setPrePaibanData', plankData.prePaibanData)
        const orderCodes = Array.from(
          new Set(plankData.preLayoutData.map((item: any) => item.orderNo))
        )
        const orderList = Array.from(
          new Set(plankData.preLayoutData.map((item: any) => item.order_id))
        )

        const proLineList = await getProductionLineSetting()

        store.commit('setProLineList', proLineList.data)
        store.commit(
          'setRecodrProductionLineChoose',
          record.production_line_name
        )
        const needPaibanRoomIds = Array.from(
          new Set(plankData.prePaibanData.map((item: any) => item.roomID))
        ).filter((i: any) => i)
        const roomIds = Array.from(
          new Set(plankData.preLayoutData.map((item: any) => item.roomID))
        ).filter((i: any) => i)

        let orderInfo = {
          order_address:
            genOrderAddress(plankData.preLayoutData).join(',') +
            '(' +
            translate('common.history') +
            ')',
          order_ids: orderList.join(','),
          order_codes: orderCodes.join(','),
          needPaibanRoomIds: needPaibanRoomIds,
          room_ids: roomIds,
          batch: plankData.batch,
        }
        store.commit('setOrderInfo', orderInfo)
        if (plankData.paibanSetting) {
          const paibanSetting = plankData.paibanSetting
          updateLocalPreference(paibanSetting)
          store.commit('setSurplusAutoTailor', paibanSetting.surplusAutoTailor)
          if (paibanSetting.surplusAutoTailor) {
            store.commit('setSurplusTailorWay', paibanSetting.surplusTailorWay)
            store.commit('setRecodeIsTailor', paibanSetting.surplusAutoTailor)
            store.commit('setLongSideRect', paibanSetting.longSideRect)
            store.commit('setShortSideRect', paibanSetting.shortSideRect)
            store.commit(
              'setSurplusCommonSize',
              paibanSetting.surplusCommonSize
            )
            store.commit(
              'setIsCombineToLShape',
              paibanSetting.isCombineToLShape
            )
            store.commit(
              'setCustomRectTemplate',
              paibanSetting.customRectTemplate
            )
          }
        }
        let hasPaibanData = true

        if (paibanDataArr.length && paibanDataJsonArr.length) {
          if (production_line_id) {
            const ncRes = await fetchGetProductionNcSetting({
              setting_id: production_line_id,
            })
            if (ncRes.data) {
              productionLineName.value = production_line_name ?? ''
              const ncSetting = Object.assign(ncRes.data, {
                process_setting_id: production_line_id,
                process_setting_name: production_line_name,
              })
              store.commit('setNcSetting', ncSetting)
              if (plankData.ncSetting) {
                const glassSetting = ncSetting.glass_setting

                if (glassSetting) {
                  await dealPaibanData(
                    [],
                    plankData.prePaibanData,
                    '',
                    true,
                    true,
                    false,
                    false,
                    false,
                    [0, 0],
                    { isPaibanTask: true, resultData: paibanDataArr }
                  )
                  // store.commit('paibanTaskStore/setIsLoading', false)
                  routerToPage(record, type, hasPaibanData)
                  return
                }
                const settingData = dealPreLayoutSettingFromNCSetting(
                  plankData.ncSetting
                )
                store.commit('setNcSetting', plankData.ncSetting)
                const compareResult = await comparePreLayoutSetting({
                  setting_value: settingData,
                  process_setting_id: production_line_id,
                  using_layout_task: true,
                })

                if (
                  compareResult.status > 0 &&
                  compareResult.data &&
                  compareResult.data.total > 0
                ) {
                  confilict.value = compareResult.data.total
                    ? compareResult.data.data
                    : null
                  confilictTotal.value = compareResult.data.total
                  currentTaskData.value = {
                    plankData,
                    paibanDataArr,
                    record,
                    type,
                    hasPaibanData,
                  }
                  store.commit('paibanTaskStore/setIsLoading', false)
                  return
                } else {
                  await dealPaibanData(
                    [],
                    plankData.prePaibanData,
                    '',
                    true,
                    true,
                    false,
                    false,
                    false,
                    [0, 0],
                    { isPaibanTask: true, resultData: paibanDataArr }
                  )
                  // store.commit('paibanTaskStore/setIsLoading', false)
                  routerToPage(record, type, hasPaibanData)
                }
              }
            } else {
              store.commit('paibanTaskStore/setIsLoading', false)
              Vue.prototype.$message({
                message: Vue.prototype.$translateLang(
                  '该条记录的生产线已被删除，请前往开料清单重新排版'
                ),
                type: 'error',
                duration: 3000,
                offset: 60,
              })
              hasPaibanData = false
            }
          }
        } else {
          // store.commit('paibanTaskStore/setIsLoading', false)
          hasPaibanData = false
          routerToPage(record, type, hasPaibanData)
        }
      } catch (error) {
        store.commit('paibanTaskStore/setIsLoading', false)
        Vue.prototype.$message({
          message: Vue.prototype.$translateLang('数据异常，请刷新页面重试'),
          type: 'error',
          duration: 3000,
          offset: 60,
        })
        throw error
        break
      }
      break
    case PaibanTaskActionEnum.PAUSE:
      handlePause(record)
      break
    case PaibanTaskActionEnum.DELETE:
      handleDelete(record)
      break
    case PaibanTaskActionEnum.CONTINUE:
      handleContinue(record)
      break
    default:
      break
  }
}

async function handleConflictModalOk() {
  const taskPaibanData = currentTaskData.value
  confilictTotal.value = 0
  confilict.value = null
  store.commit('paibanTaskStore/setIsLoading', true)
  isOkLoading.value = true

  setTimeout(async () => {
    await dealPaibanData(
      [],
      taskPaibanData.plankData.prePaibanData,
      '',
      true,
      true,
      false,
      false,
      false,
      [0, 0],
      { isPaibanTask: true, resultData: taskPaibanData.paibanDataArr }
    )
    // store.commit('paibanTaskStore/setIsLoading', false)
    confilictTotal.value = 0
    confilict.value = null
    isOkLoading.value = false
    routerToPage(
      taskPaibanData.record,
      taskPaibanData.type,
      taskPaibanData.hasPaibanData
    )
  }, 1000)
}

function handleConflictModalCancel() {
  confilict.value = null
  confilictTotal.value = 0
  store.commit('paibanTaskStore/setIsLoading', false)
}

/** 处理暂停排版任务 */
function handlePause(task: PaibanTaskRow): void {
  if (
    !checkAndShowNoPermissionToast([USER_PERMISSION_KEY.CREATE_PAIBAN_TASK])
  ) {
    return
  }

  if (task.taskStatus !== PaibanTaskStatusEnum.PENDING) {
    message.warning('仅等待中的任务可暂停')
    return
  }

  // 排版中 -> 等待中，侧栏未完成数不变
  store.dispatch('paibanTaskStore/updateTask', {
    task: task,
    action: PaibanTaskActionEnum.PAUSE,
    order_no: orderNo.value,
    status: status.value === 0 ? undefined : status.value,
    page: page.value,
    limit: limit.value,
  })

  message.success(
    `${Vue.prototype.$translateLang('已暂停任务')}：${task.taskBatch}`
  )
}

// 删除排版任务操作记录
async function saveTaskOperationRecord(taskBatch: string) {
  const record = [
    {
      key: '开料清单',
      value: [
        {
          key: '排版任务',
          value: [
            {
              key: '删除任务',
              oldValue: '任务批次',
              value: taskBatch,
            },
          ],
        },
      ],
    },
  ]
  saveDataJsonToOssForRecord(
    record,
    '开料清单',
    { id: store.state.userInfo.id },
    () => []
  )
}

/** 处理删除排版任务 */
function handleDelete(task: PaibanTaskRow): void {
  Modal.confirm({
    title: Vue.prototype.$translateLang('确认删除'),
    content: translate('paibanTask.deleteTip', {
      taskBatch: task.taskBatch,
    }),
    okText: Vue.prototype.$translateLang('删除'),
    okType: 'danger',
    cancelText: Vue.prototype.$translateLang('取消'),
    onOk() {
      // 删除后 getter unfinishedCount 自动减少
      store
        .dispatch('paibanTaskStore/updateTask', {
          task: task,
          action: PaibanTaskActionEnum.DELETE,
          order_no: orderNo.value,
          status: status.value === 0 ? undefined : status.value,
          page: page.value,
          limit: limit.value,
        })
        .then(() => {
          buryPointApi('material', 'paiban_task_deleted')
          saveTaskOperationRecord(task.taskBatch)
          message.success(Vue.prototype.$translateLang('删除成功'))
        })
    },
  })
}

/** 继续排版任务 */
function handleContinue(task: PaibanTaskRow): void {
  if (
    !checkAndShowNoPermissionToast([USER_PERMISSION_KEY.CREATE_PAIBAN_TASK])
  ) {
    return
  }
  store.dispatch('paibanTaskStore/updateTask', {
    task: task,
    action: PaibanTaskActionEnum.CONTINUE,
    order_no: orderNo.value,
    status: status.value === 0 ? undefined : status.value,
    page: page.value,
    limit: limit.value,
  })
  message.success(
    `${Vue.prototype.$translateLang('继续排版任务')}：${task.taskBatch}`
  )
}

onMounted(() => {
  store.dispatch('paibanTaskStore/fetchPaibanTaskList', {
    page: page.value,
    limit: limit.value,
  })
})

watch(maxPage, (newVal) => {
  if (page.value > newVal) {
    page.value = newVal
  }
})

return { __sfc: true,orderNo, status, page, limit, confilict, confilictTotal, productionLineName, hasConflict, isOkLoading, isLoading, displayTaskList, total, maxPage, handleSearch, loadTaskList, handlePageChange, handlePageSizeChange, currentTaskData, routerToPage, handleAction, handleConflictModalOk, handleConflictModalCancel, handlePause, saveTaskOperationRecord, handleDelete, handleContinue, MPaibanTaskConflictModal, MPaibanTaskList, statusOptions }
}

})